<template>
  <div class="home">
    <p></p>

    <b-jumbotron header="Analyze your proteins">
      <template v-slot:lead>
        With a variety of tools in one place.
      </template>
      <p>
        Psos (protein sequence observation service) integrates a variety of
        protein analysis tools and databases and removes the task to visit each
        tool website seperately. Besides that it visualizes the results. In its
        simplest form you can submit your analysis on the submit page.
        Application developers can easily integrate psos in their own
        applications.
      </p>
    </b-jumbotron>
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      background="#000000"
      img-width="1024"
      img-height="480"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide
        caption="Visualize predicted features"
        text=""
        img-src="/screenshots/features_3.png"
      ></b-carousel-slide>

      <b-carousel-slide
        caption="Visualize identified homologies"
        text=""
        img-src="/screenshots/homologies_1.png"
      ></b-carousel-slide>

      <b-carousel-slide
        caption="Analyze referenced entries"
        text=""
        img-src="/screenshots/wordcloud_tooltip.png"
      ></b-carousel-slide>

      <b-carousel-slide img-src="/screenshots/submit_1.png">
        <h3><router-link to="submit">Submit your data</router-link></h3>
      </b-carousel-slide>

      <b-carousel-slide
        caption="Integrate psos into your application"
        text=""
        img-src="/screenshots/gendb_integration.png"
      ></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
// @ is an alias to /src
import Layout from "@/mixins/public-layout.vue";

export default {
  name: "Home",
  mixins: [Layout],
  components: {},
  data() {
    return {
      slide: 0,
      sliding: null
    };
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    }
  }
};
</script>
<style>
.carousel-caption {
  color: #333;
  border: solid;
  border-color: black;
  border-width: thin;
  border-radius: 15px 15px 15px 15px;
  background-color: #e9ecef;
}
.carousel-caption h3 {
  color: #333;
}
.carousel-caption p {
  color: #333;
}
.carousel-indicators li {
  background-color: #777;
}
#carousel-1 {
  border-style: solid;
  border-color: #e9ecef;
  border-width: thin;
}
</style>
